<template>
    <v-checkbox
        dense
        :hide-details="hideDetails"
        v-model="inputValue"
        :error-messages="$props.error"
        :readonly="$props.readonly"
        :label="$props.label"
    ></v-checkbox>
</template>

<script>
export default {
    name: 'CheckBox',
    props: {
        value: Boolean,
        label: String,
        readonly: Boolean,
        error: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            inputValue: this.$props.value
        };
    },
    computed: {
        hideDetails() {
            return this.$props.error === '';
        }
    },
    watch: {
        inputValue() {
            this.$emit('input', this.inputValue);
        },
        value() {
            this.inputValue = this.$props.value;
        }
    }
};
</script>

<style scoped></style>
